import {Exclude, Type} from 'class-transformer';
import { ExpressionModel } from '../../common/expression.model';
import { PropertyMappingModel } from '../../properties/models/property-mapping.model';
import {InstructionType, MasterInstructionModel} from "./master-input-instruction.model";
import {SpecLineModel} from "../../properties/models/spec-line.model";

export class MasterUseInstructionModel extends MasterInstructionModel {
  private _validFromTo: [Date, Date];

  constructor(init?: Partial<MasterUseInstructionModel>) {
    super();
    Object.assign(this, init);
    this.Type = InstructionType.Use;
  }

  MasterOperationId: string;
  SetupDuration: ExpressionModel = new ExpressionModel();
  ProductionDuration: ExpressionModel = new ExpressionModel();
  TeardownDuration: ExpressionModel = new ExpressionModel();
  RequiredResourceQuantity: number;
  IsMainResource: boolean;
  TimeConstraintMethodClv?: string;
  TimeConstraintMin: ExpressionModel = new ExpressionModel();
  TimeConstraintMax: ExpressionModel = new ExpressionModel();
  MaxSuspendTimeForProduction: ExpressionModel = new ExpressionModel();
  ValidCondition: ExpressionModel = new ExpressionModel();
  TaskSelectorId?: string;
  @Type(() => Date)
  ValidFrom?: Date;
  @Type(() => Date)
  ValidTo?: Date;
  OperationSplitSizeMax?: number;
  @Exclude({ toPlainOnly: true })
  $InheritedOperationPropertyMappings: PropertyMappingModel[];
  @Type(() => PropertyMappingModel)
  OperationItemProperties: PropertyMappingModel[]  = [];
  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];

  get ValidFromTo() {
    if (!this._validFromTo) {
      this._validFromTo = [this.ValidFrom, this.ValidTo];
    }
    return this._validFromTo;
  }

  set ValidFromTo(dates: [Date, Date]) {
    this._validFromTo = dates;
    this.ValidFrom = dates[0];
    this.ValidTo = dates[1];
  }

  Sequence?: number;
  ParentValidCondition?: string;
  ParentProductionDuration?: string;
  Resources: string[] = [];
  UserSpecifiedResources: string[] = [];
  ResourceTemplateId: string;
  Yield: ExpressionModel = new ExpressionModel();
}
